import { locationSearchFormStyles } from "@insite/content-library/Components/LocationSearchForm";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import { css } from "styled-components";

locationSearchFormStyles.searchButton = {
    css: css`
        border-radius: 25px;
        background-color: ${getColor("warning")};
        border: 1px solid ${getColor("warning")};
        &:hover {
            background: ${getColor("warning.contrast")};
            border: 1px solid ${getColor("warning.contrast")};
        }
        span {
            color: ${getColor("info.contrast")} !important;
            font-size: ${TYPOGRAPHY.size.smallest} !important;
            opacity: 1;
            font-weight: ${TYPOGRAPHY.weight.baseBold};
            font-style: normal;
            letter-spacing: ${TYPOGRAPHY.letterSpacing.vSmaller};
            text-align: left;
        }
    `,
};

locationSearchFormStyles.searchResultPhoneLink = {
    css: css`
        &:focus {
            outline: none;
        }
    `,
};

locationSearchFormStyles.locationGoogleMapsDirectionLink = {
    css: css`
        &:focus {
            outline: none;
        }
    `,
};

locationSearchFormStyles.pagination = {
    cssOverrides: {
        pagination: css`
            justify-content: center;
            background-color: ${COLORS.background.base};
            height: 30px;
            text-transform: uppercase;
            font-size: ${TYPOGRAPHY.size.smallest};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 35px;
                    `,
                    css`
                        margin-bottom: 35px;
                    `,
                    css`
                        margin-bottom: 35px;
                    `,
                    null,
                    null,
                ])}
        `,
        perPageSelect: css`
            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            display: none;
                        `,
                        null,
                        null,
                        null,
                        null,
                    ],
                    "min",
                )}
        `,
        currentButton: css`
            min-height: 30px;
            background: ${getColor("primary")};
            border-radius: 0px;
            span {
                color: ${COLORS.white}!important;
            }
            &:hover {
                background: ${getColor("primary")};
            }
        `,
    },
    buttonProps: {
        mergeCss: true,
        css: css`
            border-radius: 0px;
            border: none;
            color: ${getColor("text.main")};
            [class^="TypographyStyle"] {
                color: inherit;
            }
            &:hover {
                background: ${COLORS.border.base};
            }
            &:active {
                background: ${COLORS.border.base};
            }
        `,
    },
};

locationSearchFormStyles.locationNameLink = {
    typographyProps: {
        weight: "bold",
        ellipsis: true,
    },
    css: css`
        &:focus {
            outline: none;
        }
        > span {
            color: ${getColor("primary")} !important;
            white-space: normal;
            &:hover {
                color: ${getColor("secondary")}!important;
            }
        }
    `,
};

locationSearchFormStyles.locationDisplayNumberText = {
    weight: "bold",
    css: css`
        color: ${getColor("primary")}!important;
    `,
};

locationSearchFormStyles.searchResultGoogleMapsDirectionLinkGridItem = {
    width: [4, 4, 4, 3, 4],
};

locationSearchFormStyles.searchResultDistanceGridItem = {
    width: [6, 6, 6, 4, 4],
};

locationSearchFormStyles.searchResultPhoneGridItem = {
    width: [11, 11, 11, 11, 3],
};
